import { createBrowserRouter, Navigate } from 'react-router-dom';

// import Communication from 'pages/Communication';
import Default from 'pages/Default';
import Mypage from 'pages/Mypage';
import SignIn from 'pages/SignIn';
import { retryLazy } from 'util/lazyUtil';

// import AuthGuard from './AuthGuard';
import AuthGuard from './AuthGuard';
import ProtectedRoute from './ProtectedRoute';

const Home = retryLazy(() => import('pages/Home'));
const Admin = retryLazy(() => import('pages/Admin'));
const AdminDetail = retryLazy(() => import('pages/AdminDetail'));
const UserList = retryLazy(() => import('pages/UserList'));
const UserDetail = retryLazy(() => import('pages/UserDetail'));
const AuthConfirmPassword = retryLazy(() => import('pages/AuthConfirmPassword'));

const InquiryList = retryLazy(() => import('pages/InquiryList'));
const InquiryDetail = retryLazy(() => import('pages/InquiryDetail'));
const Notice = retryLazy(() => import('pages/Notice'));
const NoticeDetail = retryLazy(() => import('pages/NoticeDetail'));
const CustomerList = retryLazy(() => import('pages/CustomerList'));
const CustomerDetail = retryLazy(() => import('pages/CustomerDetail'));
const GatewayList = retryLazy(() => import('pages/GatewayList'));
const GatewayDetail = retryLazy(() => import('pages/GatewayDetail'));
const ClientList = retryLazy(() => import('pages/ClientList'));
const ClientDetail = retryLazy(() => import('pages/ClientDetail'));

const routes = createBrowserRouter(
  [
    {
      path: '/sign-in',
      element: (
        <AuthGuard>
          <SignIn />
        </AuthGuard>
      ),
    },
    {
      path: '/',
      element: (
        <AuthGuard>
          <Default />
        </AuthGuard>
      ),
      children: [
        { path: '/home', element: <Home /> },
        { path: '/auth-confirm', element: <AuthConfirmPassword /> },
        {
          path: '/mypage',
          element: (
            <ProtectedRoute>
              <Mypage />
            </ProtectedRoute>
          ),
        },
        {
          path: '/gateway',
          children: [
            {
              path: '',
              element: <GatewayList />,
            },
            {
              path: ':gatewayId',
              element: <GatewayDetail />,
            },
          ],
        },
        {
          path: '/client',
          children: [
            {
              path: '',
              element: <ClientList />,
            },
            {
              path: ':clientId',
              element: <ClientDetail />,
            },
          ],
        },
        {
          path: '/user',
          children: [
            {
              path: '',
              element: <UserList />,
            },
            {
              path: ':userId',
              element: <UserDetail />,
            },
          ],
        },
        {
          path: '/customer',
          children: [
            {
              path: '',
              element: <CustomerList />,
            },
            {
              path: ':customerId',
              element: <CustomerDetail />,
            },
          ],
        },
        {
          path: '/admin',
          children: [
            {
              path: '',
              element: <Admin />,
            },
            {
              path: ':userId',
              element: <AdminDetail />,
            },
          ],
        },
        {
          path: '/board',
          children: [
            {
              path: 'notice',
              children: [
                {
                  path: '',
                  element: <Notice />,
                },
                {
                  path: ':noticeId',
                  element: <NoticeDetail />,
                },
              ],
            },
            {
              path: 'inquiry',
              children: [
                {
                  path: '',
                  element: <InquiryList />,
                },
                {
                  path: ':inquiryId',
                  element: <InquiryDetail />,
                },
              ],
            },
          ],
        },
      ],
    },
    { path: '/*', element: <Navigate to={'/home'} replace /> },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_fetcherPersist: true,
      v7_skipActionErrorRevalidation: true,
    },
  },
);

export default routes;
